// extracted by mini-css-extract-plugin
module.exports = {"root":"_1PFJ0FbxuUaj3jXdtEKZPi","small":"_1nryZg2Z1XZu0dpRc7-Bqu"};